import React from 'react';
import {Link} from 'react-router';
import {observer, inject} from 'mobx-react';
import {observable, autorun, toJS} from "mobx";
import {Paper} from 'material-ui';
import Observation from './Observation';
import StationSpecificMap from './StationSpecificMap';
import StationInfoMob from './StationInfoMob';
import {CircularProgress} from 'material-ui';
import {rainfallWarning} from "../../libs/config";
import LatestObservation from "./LatestObservation";

@inject('markerStore')
@observer
class StationDetails extends React.Component {

  @observable station = null;
  @observable infoFromMarker = null;
  @observable id = null;

  reset;
  componentWillMount(){
    this.id = this.props.params.id;
    this.reset = autorun(() => {
      const {markerStore} = this.props;
      this.infoFromMarker = markerStore.markers.filter(marker => +marker.id === +this.id);
      this.station = markerStore.getCombinedMarkers.find(station => +station.id === +this.id)
      // stationStore.fetchById(this.id)
      //   .then(res => {
      //     this.station = res;
      //   });
    });
  }

  componentWillReceiveProps(nextProps){
    this.id = nextProps.params.id
  }

  style = {width:'100%', padding:'10px', marginBottom:'10px', height:'255px'};

  render() {
    // console.log(toJS(this.infoFromMarker));
    if(!this.station ) return(<div className="spinner"><CircularProgress/></div>);
    let tableWidth, mapWidth;
    if(this.station.images){
      tableWidth='40%';
      mapWidth='25%'
    }else{
      tableWidth = '65%';
      mapWidth = '29%'
    }

    let waterLevel = this.infoFromMarker.filter(mk => mk.type === 'waterlevel')[0];
    let rainfall = this.infoFromMarker.filter(mk => mk.type === 'rainfall')[0];

    const roundOff = (value, dec) => Math.round(value*Math.pow(10,dec))/Math.pow(10,dec);

    if(!this.props.mobView) {
      return (
        <div className="stationDetails">
          <Paper style={this.style} zDepth={1}>
            <div style={{width: '100%'}} className="inline-it">
              <div style={{width: tableWidth}}>
                <div className="stationTitle">{this.station.name}</div>
                <table className="table infoTable">
                  <tbody>
                  <tr>
                    <th>Station Index</th>
                    <td>{waterLevel && waterLevel.stationIndex ? waterLevel.stationIndex : rainfall && rainfall.stationIndex? rainfall.stationIndex : ''}</td>
                  </tr>
                  {/*<tr><th>Name</th><td>{this.station.name}</td></tr>*/}
                  <tr>
                    <th>Latitude</th>
                    <td>{roundOff(this.station.position.lat, 2)}</td>
                  </tr>
                  <tr>
                    <th>Longitude</th>
                    <td>{roundOff(this.station.position.lng, 2)}</td>
                  </tr>
                  <tr>
                    <th>Elevation</th>
                    <td>{this.station.elevation}</td>
                  </tr>
                  <tr>
                    <th>District</th>
                    <td>{waterLevel && waterLevel.district ? waterLevel.district : rainfall && rainfall.district? rainfall.district : ''}</td>
                  </tr>
                  <tr>
                    <th>Description</th>
                    <td>{this.station.description}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div style={{width: mapWidth}}>
                <StationSpecificMap
                  station={{...this.station, icon: waterLevel && waterLevel.icon ? waterLevel.icon : this.station.icon}}/>
              </div>
              {this.station.images &&
              <div>
                <Link to={`/basin/${this.props.params.id}/image`}>
                  <img style={{height: '200px'}} src={`http://daq.hydrology.gov.np/images/${this.station.images[0].name}`} alt="not found"/>
                </Link>
              </div>}
            </div>
          </Paper>
          {(waterLevel || rainfall) &&
          <div>
            <LatestObservation waterLevel={waterLevel} rainfall={rainfall}/>
            <br/>
            {((waterLevel && waterLevel.series_id) || (rainfall && rainfall.series_id)) &&
            <Paper zdepth={1}>
              <Observation waterLevelId={waterLevel && waterLevel.series_id} rainfallId={rainfall && rainfall.series_id} thresholds={waterLevel && waterLevel.thresholds}/>
            </Paper>}
          </div>}
          <br/>
          {this.props.children ? React.cloneElement(this.props.children, { images: this.station.images, slug:`/basin/${this.props.params.id}` }) :null}
        </div>
      );
    }else{
      return(
        <StationInfoMob station={this.station} waterlevel={waterLevel} rainfall={rainfall} toggleOpen={this.props.toggleOpen} />
      );
    }
  }
}

export default StationDetails;



// WEBPACK FOOTER //
// ./src/components/Station/StationInfo.js